exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_list_2r8Q6TRV5tB23sYpujir_1 {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  background-position: center;\n  background-size: cover;\n}\n\n.IA_headline_2oJzuWf1gnlIfxv5sWk2Mp {\n  width: 100%;\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_list": "IA_list_2r8Q6TRV5tB23sYpujir_1",
	"IA_headline": "IA_headline_2oJzuWf1gnlIfxv5sWk2Mp"
};